﻿import Repository from "./Repository";
const dossierDataResource = "dossier/dossierdata";
const dossierUpdateResource = "dossier/updatedossier";
const cardUpdateResource = {
  personeelslid: "dossier/updatepersoneelslid",
  contact: "dossier/updatecontact",
  gezin: "dossier/updategezin",
  overige: "dossier/updateoverige",
};
const dossierInsertAllFilesResource = "dossier/insertallfiles";
const dossierInsertFilesResource = "dossier/insertfiles";
const dossierChRequestsResource = "dossier/ChRequests";
const dossierDownloadFileResource = "dossier/downloaddossierfile";
const dossierDeleteStepResource = "dossier/deletechreqstep";
const dossierVeldenResource = "dossier/dossiervelden";
const dossierSubmitAdditionResource = "dossier/addaddition";
const dossierDisableWizardRequiredResource = "dossier/removeoption";

export default {
  getDossier() {
    return Repository.get(dossierDataResource);
  },
  getChangeRequests() {
    return Repository.post(dossierChRequestsResource);
  },
  getDossierVelden() {
    return Repository.get(dossierVeldenResource);
  },
  downloadDossierFile(pStep, pDossierFile) {
    var fd = new FormData();
    fd.append("pStep", pStep);
    fd.append("pDossierFile", pDossierFile);
    return Repository.post(dossierDownloadFileResource, fd, {
      responseType: "blob",
    });
  },
  deleteDossierStep(pRequest, pStep) {
    var fd = new FormData();
    fd.append("pRequest", pRequest);
    fd.append("pStep", pStep);
    return Repository.post(dossierDeleteStepResource, fd);
  },
  postDossierChanges(before, after, remark, bestandenPerCard) {
    return Repository.post(dossierUpdateResource, {
      before,
      after,
      remark,
    }).then((res) => {
      const addedSteps = res.data.s;
      const pReq = res.data.p;
      const fd = new FormData();
      addedSteps.forEach((val) => {
        fd.append("pSteps", val);
      });
      fd.append("pRequest", pReq);
      for (let card in bestandenPerCard) {
        bestandenPerCard[card].forEach((file) => {
          fd.append(card, file);
        });
      }
      Repository.post(dossierInsertAllFilesResource, fd);
    });
  },
  postCardChanges(before, after, remark, bestanden, cardName) {
    return Repository.post(cardUpdateResource[cardName], {
      before,
      after,
      remark,
    }).then((res) => {
      const addedStep = res.data.s;
      return this.insertStepFiles(addedStep, bestanden);
    });
  },
  submitDossierAddition(pRequest, remark, attachments, cardName) {
    let pCard;
    if (cardName === "personeelslid") {
      pCard = 1;
    }
    if (cardName === "contact") {
      pCard = 2;
    }
    if (cardName === "gezin") {
      pCard = 3;
    }
    if (cardName === "overige") {
      pCard = 4;
    }
    var fd = new FormData();
    fd.append("pRequest", pRequest);
    fd.append("remark", remark);
    fd.append("pCard", pCard);
    return Repository.post(dossierSubmitAdditionResource, fd).then((res) => {
      const addedStep = res.data.s;
      return this.insertStepFiles(addedStep, attachments);
    });
  },
  insertStepFiles(step, bestanden) {
    const fd = new FormData();
    fd.append("pStep", step);
    bestanden.forEach((file) => {
      fd.append("bestanden", file);
    });
    return Repository.post(dossierInsertFilesResource, fd);
  },
  disableWizardRequired() {
    const fd = new FormData();
    fd.append("optionName", "wizard-required");
    return Repository.post(dossierDisableWizardRequiredResource, fd);
  },
};
